import { GOOGLE_API_KEY } from 'src/config';

export const GOOGLE_MAPS_BASE_OPTIONS = {
  id: 'script-loader',
  googleMapsApiKey: GOOGLE_API_KEY,
  language: 'en',
  region: 'EN',
  version: 'weekly',
};

export const GOOGLE_MAPS_DEFAULT_LIBRARIES = [
  'drawing',
  'visualization',
  'places',
];

export const buildGoogleMapsOptions = (
  libraries = GOOGLE_MAPS_DEFAULT_LIBRARIES
) =>
  libraries && libraries.length
    ? { ...GOOGLE_MAPS_BASE_OPTIONS, libraries }
    : { ...GOOGLE_MAPS_BASE_OPTIONS };
